import type StudyModel from '../../../models/StudyModel';
import { requestAndParse, requestSuccessful } from '../request';

const getStudies = async (searchTerm?: string) => {
    const route = 'admin/get-studies';
    const payload = { searchTerm };

    const response = await requestAndParse(route, payload, 'GET');

    const success = requestSuccessful(response);
    const studies = (response.body?.studies ?? []) as StudyModel[];

    return { success, studies };
};

export default getStudies;
